import { sendBrowserPerformanceMetrics, PerformanceMarks } from '@fiverr-private/obs';

window.addEventListener(
    'load',
    () => {
        if (typeof performance === 'object' && typeof performance.mark === 'function') {
            performance.mark(PerformanceMarks.WINDOW_LOAD);
        }
        setTimeout(sendBrowserPerformanceMetrics, 1000);
    },
    { once: true }
);
